import React from 'react'
import PropTypes from 'prop-types'
import Box from '@material-ui/core/Box'
import CustomNumericMenu from './CustomNumericMenu'
import CustomRangeInput from './CustomRangeInput'
import CustomRefinementList from './CustomRefinementList'
import CustomToggleRefinement from './CustomToggleRefinement'
import DistanceInput from './DistanceInput'
import { useStyles } from './Refiners.styles'

const GroupEventsResultsRefiners = (props) => {
  const {
    showRefiners,
    isMobile,
  } = props
  const isVisible = showRefiners || !isMobile
  const styles = useStyles()
  return (
    <Box className={styles.scrollWrapper} display={isVisible ? 'block' : 'none'}>
      <Box display="flex" data-cy="ttd-filters">
        <CustomNumericMenu
          attribute="total_price_in_cents"
          items={[
            { label: 'Show All' },
            { label: 'Less Than $25', end: 2500 },
            { label: 'Less Than $50', end: 5000 },
            { label: 'Less Than $100', end: 10000 },
          ]}
        />
        <CustomRefinementList attribute="tags" operator="or" />
        <CustomRangeInput attribute="start_date_time_ts" />
        <DistanceInput {...props} />
        <CustomToggleRefinement
          attribute="registration_full"
          label="Open for Registration"
          value={false}
        />
      </Box>
    </Box>
  )
}

GroupEventsResultsRefiners.propTypes = {
  showRefiners: PropTypes.bool.isRequired,
  isMobile: PropTypes.bool.isRequired,
}
export default GroupEventsResultsRefiners
